import { fetchCourseListPublic } from "services/courseService";

import {
  fetchAllCourses,
  fetchSingleCourse,
  courseErrorMsg,
  setCourseLoader,
  setPagination,
} from "./reducer";

export const fetchCoursesPublic = (data: any) => async (dispatch: any) => {
  dispatch(setCourseLoader(true));
  try {
    const response = await fetchCourseListPublic(data);

    if (response.success) {
      dispatch(setPagination(response.data.pagination));

      if (data.course_id && data.course_id !== 0) {
        dispatch(fetchSingleCourse(response));
      } else {
        dispatch(fetchAllCourses(response));
      }
    } else {
      dispatch(
        courseErrorMsg(response.message || "Failed to fetch courses")
      );
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong";
    dispatch(courseErrorMsg(errorMessage));
  } finally {
    dispatch(setCourseLoader(false));
  }
};


